import { render } from "./updatePassword.vue?vue&type=template&id=27fad475"
import script from "./updatePassword.vue?vue&type=script&lang=js"
export * from "./updatePassword.vue?vue&type=script&lang=js"

import "./updatePassword.vue?vue&type=style&index=0&id=27fad475&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__